import { createAuthClient } from 'better-auth/react';

/**
 * Better Auth browser client. Same-origin: the SPA and the API are served by
 * one container, so the client talks to /api/auth/* on the same host.
 */
export const authClient = createAuthClient();

export const { signIn, signOut, useSession } = authClient;

/** Start the Google Workspace OIDC flow. Domain restriction is enforced server-side. */
export function signInWithGoogle(callbackURL = '/') {
  return signIn.social({ provider: 'google', callbackURL });
}
